var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createContext, memo, useContext, useEffect, useState, } from 'react';
import { Container } from './container';
import { useDataFromContainer } from './use-data-from-container';
const fallbackContainer = new Container(() => { });
export function createStore(hook, options) {
    var _a;
    const shouldMemo = (_a = options === null || options === void 0 ? void 0 : options.memo) !== null && _a !== void 0 ? _a : true;
    // TODO: forwardRef
    const StoreContext = createContext(fallbackContainer);
    const IsolatorContext = createContext({
        node: undefined,
    });
    const IsolatorOuter = props => {
        return (React.createElement(IsolatorContext.Provider, { value: {
                node: props.node,
            } }, props.children));
    };
    const IsolatorInner = memo(props => {
        const { node } = useContext(IsolatorContext);
        return React.createElement(React.Fragment, null, node);
    }, () => true);
    const StoreExecutor = memo(props => {
        const { children } = props, p = __rest(props, ["children"]);
        const [container] = useState(() => new Container(hook));
        container.data = hook(p);
        useEffect(() => {
            container.notify();
        });
        return (React.createElement(StoreContext.Provider, { value: container }, props.children));
    });
    const StoreProvider = props => {
        return (React.createElement(IsolatorOuter, { node: props.children },
            React.createElement(StoreExecutor, Object.assign({}, props),
                React.createElement(IsolatorInner, null))));
    };
    function useStore(depsFn) {
        const container = useContext(StoreContext);
        if (container === fallbackContainer) {
            // TODO
            console.error("Failed to retrieve the store data from context. Seems like you didn't render a outer StoreProvider.");
        }
        return useDataFromContainer(container, depsFn);
    }
    return [useStore, shouldMemo ? memo(StoreProvider) : StoreProvider];
}
